export default __webpack_public_path__ + "static/media/3.56b17ea4.png";